<template><!--个人中心》我的钱包》积分转账-->
    <div class="integralPage il-pad" style="background-color:#ffffff">
        <div v-if="page_type == 1" style="height:332px;">
            <div class="il-box dis-between">
                <div class="dis" style="margin:auto 0" >
                    <div class="il-p">转让到917 VIP账户</div>
                    <div class="il-p2">积分将实时到账，请确认再转让&nbsp;&nbsp;<span style="color:#11D165;">当前积分：{{myBalance.tokenmoney}}</span></div>
                </div>
                <div style="margin:auto 0;color:#11D165;cursor:pointer" @click="recordFn">转让记录</div>
                <!-- <div style="margin:auto 0">当前积分：{{myBalance.tokenmoney}}</div> -->
            </div>
            <div class="group dis-cen">
                <div class="dis">
                    <div class="il-p3">对方账户:</div>
                    <div style="margin-top:24px">
                        <div class="il-box2">
                            <input type="number" class="il-input" v-model="vipNo" placeholder="917VIP账户" />
                        </div>
                        <div class="il-but" @click="nextClick">下一步</div>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="page_type == 2" style="height:500px;">
            <div class="il-box dis-between">
                <div class="dis" style="margin:auto 0" >
                    <div class="il-p">转让到917 VIP账户</div>
                    <div class="il-p2">积分将实时到账，请确认再转让</div>
                </div>
                <div style="margin:auto 0;color:#11D165;cursor:pointer" @click="recordFn">转让记录</div>
            </div>
            <div class="group dis-cen">
                <div class="dis">
                    <div class="il-p3">对方账户:</div>
                    <div style="margin-top:24px">
                        <div class="il-box2 dis-cen">
                            <div class="dis">
                                <img style="width:40px;height:40px" src="../../../assets/image/iocn/TX.png" />
                                <div class="il-p4">{{userObj.name}}</div>
                                <div class="il-p4" style="margin:auto 0">vip号:{{vipNo}}</div>
                                <div class="il-p4">手机号:{{userObj.phone}}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="group dis-cen" style="margin:24px 0 0 0">
                <div class="dis" style="margin-left:30px" >
                    <div class="il-p3" style="margin-top:30px">转让积分:</div>
                    <div class="dis">
                        <div  @click="valueClick(1)">
                            <div class="userrec-box" :class="type == 1?'userrec-act-bor':''">100</div>
                            <div class="userrec-img2 dis-end" style="width:160px"><img v-if="type == 1" src="../../../assets/image/iocn/gouxuan.png" /></div>
                        </div>
                        <div  @click="valueClick(2)">
                            <div class="userrec-box" :class="type == 2?'userrec-act-bor':''">200</div>
                            <div class="userrec-img2 dis-end" style="width:160px"><img v-if="type == 2" src="../../../assets/image/iocn/gouxuan.png" /></div>
                        </div>
                        <div  @click="valueClick(3)">
                            <div class="userrec-box" :class="type == 3?'userrec-act-bor':''">300</div>
                            <div class="userrec-img2 dis-end" style="width:160px"><img v-if="type == 3" src="../../../assets/image/iocn/gouxuan.png" /></div>
                        </div>
                        <div  @click="valueClick(4)">
                            <div class="userrec-box" :class="type == 4?'userrec-act-bor':''" style="margin:0 0">
                                <div class="dis" style="width:60%;margin:0 auto">
                                    <div class="userrec-color" :class="type == 4?'userrec-act-color':''" style="color:#ffffff">¥</div>
                                    <input type="text" v-if="type != 4" class="userrec-input" v-model="value" placeholder="其它金额" style="width:81%;font-size: 18px;" />
                                    <input type="number" v-else class="userrec-input" v-model="value" />
                                </div>
                            </div>
                            <div class="userrec-img2 dis-end" style="width:160px"><img v-if="type == 4" src="../../../assets/image/iocn/gouxuan.png" /></div>
                        </div>
                    </div>
                    <div style="margin:30px 0 0 16px;color:#707070">分</div>
                </div>
            </div>
            <div class="group dis-cen">
                <div class="dis">
                    <div class="il-p3">支付密码:</div>
                    <div style="width: 712px;height: 20px;">
                        <div class="dis withdra-he" style="width:82%;border:none;margin-top:24px">
                            <el-input style="width:160px" type="password" v-model="password"></el-input>
                            <div class="withdra-color" @click="wjpasswordClick">&nbsp;&nbsp;&nbsp;&nbsp;忘记密码</div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="group dis-cen">
                <div class="dis">
                    <div class="il-p3" style="width:67.86px" ></div>
                    <div style="width: 712px;height: 20px;">
                        <div class="il-but" @click="readClick">确认转让</div>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="page_type == 3">
            <div class="rechargeRecord">
                <div class="transaction-tips dis-between">
                    <div class="dis">
                        <img class="jfzz-img" style="cursor:pointer;" @click="closeClick" src="../../../assets/image/iocn/close.png" />
                        <div class="jfzz-p">积分转让记录</div>
                    </div>
                    <div class="dis">
                        <div class="transaction-record-title" style="margin: auto 0;color:#484848">筛选：</div>
                        <div class="found-time-box">
                            <el-date-picker
                                v-model="value2"
                                type="datetimerange"
                                :picker-options="pickerOptions"
                                range-separator="至"
                                start-placeholder="开始日期"
                                end-placeholder="结束日期"
                                align="right"
                                @change = "pickerReadClick"
                            ></el-date-picker>
                        </div>
                    </div>
                </div>
                <div style="height:24px"></div>
                <div v-if="rechargeList.length > 0">
                    <div v-for="(item,index) in rechargeList" :key="index" class="group jfzz-box">
                        <div class="dis-between">
                            <div class="jfzz-p2">{{item.sellUserName}}&nbsp;(&nbsp;{{item.sellVipNo}}&nbsp;)<span>&nbsp;&nbsp;&nbsp;转让给&nbsp;&nbsp;&nbsp;</span>{{item.buyUserName}}&nbsp;(&nbsp;{{item.buyVipNo}}&nbsp;)</div>
                            <div class="jfzz-p4" :class="new_vipCard !== item.sellVipNo?'jfzz-col':''"><span v-if="new_vipCard == item.buyVipNo">+</span><span v-else>-</span>{{item.tokenMoney}}</div>
                        </div>
                        <div class="dis-between" style="margin:8px 0 0 0">
                            <div class="jfzz-p3">订单号&nbsp;{{item.tradNo}}</div>
                            <div class="jfzz-p3">{{item.addTime}}</div>
                        </div>
                    </div>
                </div>
                <div v-else style="text-align:center;line-height:350px">暂无数据</div>
                <div class="list-page dis-end myBalance-pagination" style="margin-top:24px">
                    <el-pagination
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :current-page="currentPage"
                        :page-sizes="[100, 200, 300, 400]"
                        :page-size="pageSize"
                        layout="total, prev, pager, next, jumper"
                        :total="totalLength"
                    >
                    </el-pagination>
                </div>
            </div>
        </div>
    </div>
</template>

<style scoped>
    .il-pad{padding:24px;box-sizing: border-box;}
    .il-box{padding:0 24px;box-sizing: border-box;height: 56px;background: #F1F1F1;}
    .il-p{margin-right:23px;font-size: 18px;font-family: PingFang SC;font-weight: 500;color: #434343;}
    .il-p2{font-size: 16px;font-family: PingFang SC;font-weight: 500;color: #999999;}
    .il-p3{margin-top:40px;margin-right:20px;font-size: 16px;font-family: PingFang SC;font-weight: 500;color: #6F6F6F;}
    .il-box2{width: 712px;height: 56px;border: 1px solid #CACACA;}
    .il-input{font-size: 18px; text-align: center;width:100%;height:54px;border:none;outline: none;}
    .il-but{text-align: center;line-height: 40px;font-size: 18px;font-family: PingFang SC;font-weight: 500;color: #FFFFFF;margin-top:40px;width: 160px;height: 40px;background: #11D165;cursor: pointer;}

    input:focus{outline:medium;}
    .userrec-wid{width:100%;line-height:56px;background: #F1F1F1;font-size: 18px;padding-left:24px;font-family: PingFang SC;font-weight: 500;color: #434343;line-height: 56px;}
    .userrec-img{width:24px;height:26px;margin:auto 0;margin-right:23px}
    .userrec-box{text-align: center;font-size: 22px;font-family: PingFang SC;font-weight: 500;color: #999999;line-height: 78px;width: 160px;height:80px;border:1px solid #CACACA;cursor: pointer;margin-right: 24px;}
    .userrec-act-bor{border: 2px solid #11D165;color:#11D165}.userrec-color{color: #999999;}.userrec-act-color{color: #11D165;}
    .userrec-img2{position: relative;top:-26px;z-index: 3;}
    .userrec-input{width:80%;margin:auto 0;height:30px;border:none;color:#11D165;font-size: 22px;}

    .il-p4{font-size: 18px;font-family: PingFang SC;font-weight: 500;color: #333333;margin:auto 24px}
    .list-page >>> .el-pagination .btn-prev {margin-right: 5px;}

</style>

<script>
    export default
    {
        name: 'integralPage',
        props: { parentName: { type: Object } },
        data()
        {
            return {
                page_type: 1,
                myBalance: {},
                vipNo: '',
                userObj: {},

                value: '',
                type: -1,
                set_value: -1,
                password: '',
                //+--------------------------------------------------------
                pickerOptions: {
                    shortcuts: [
                        {
                            text: "最近一周",
                            onClick(picker) {
                                const end = new Date()
                                const start = new Date()
                                start.setTime(
                                    start.getTime() - 3600 * 1000 * 24 * 7
                                )
                                picker.$emit("pick", [start, end])
                            }
                        },
                        {
                            text: "最近一个月",
                            onClick(picker) {
                                const end = new Date()
                                const start = new Date()
                                start.setTime(
                                    start.getTime() - 3600 * 1000 * 24 * 30
                                )
                                picker.$emit("pick", [start, end])
                            }
                        },
                        {
                            text: "最近三个月",
                            onClick(picker) {
                                const end = new Date()
                                const start = new Date()
                                start.setTime(
                                    start.getTime() - 3600 * 1000 * 24 * 90
                                )
                                picker.$emit("pick", [start, end])
                            }
                        }
                    ]
                },
                value2: "",
                rechargeList: [], //充值记录
                DateStart: '',
                DateEnd: '',
                pageNo: 1,
                totalPage: 0, //总页数
                pageSize: 5,
                totalLength: 0, //总条数
                currentPage: 1,
                new_vipCard: 0,
                //+--------------------------------------------------------
                bol: false,
            };
        },
        created()
        {
            this.getBalance()
        },
        methods:
        {
            getBalance() {
                this.$api.order.UserBalances().then(res => {
                    if (res.data.code == 0) {
                        this.myBalance = res.data.result
                    } else {
                        let name = res.data.message
                        this.checkTips(name, "warning")
                    }
                })
            },
            nextClick() {
                this.$loading()
                let params = {vipNo: this.vipNo}
                this.$api.product.GetVipInfoByVipNo( params ).then( res =>
                {
                    this.$loading().close()
                    if ( res.data.code == 0 )
                    {
                        this.userObj = res.data.result
                        this.password = ''
                        this.type = -1
                        this.page_type = 2
                    }
                    else
                    {
                        let name = res.data.message;
                        this.checkTips( name, 'warning' );
                    }
                } )
            },
            valueClick(val) {
                this.value = ''
                this.set_value = -1

                if (this.set_value == val) return
                if (val == 1) {
                    this.set_value = 100
                } else if (val == 2) {
                    this.set_value = 200
                } else if (val == 3) {
                    this.set_value = 300
                }
                this.type = val
            },
            readClick() {
                if (this.set_value == -1 && !this.value) {
                    this.checkTips( "请选择或输入转让值", 'warning' );
                    return
                }
                if (!this.password) {
                    this.checkTips( "请填写支付密码", 'warning' );
                    return
                }
				this.$loading()
				let money = 0
				if (this.set_value > 0) {
					money = Number(this.set_value)
				} else {
					money = Number(this.value)
				}

                if (this.value % 100) {
                    this.checkTips( "请输入100的倍数", 'warning' );
                    this.$loading().close()
                    return
                }
				let paramsTwo = {
                    buyvipno: this.vipNo,
					tokenmoney: money
				}

                let params = {PayPwd: this.password}
                this.$api.product.VerifyPayPwd(params).then((res) => {
                    if ( res.data.code == 0 )
                    {
                        this.reqFn(paramsTwo)
                    }else
                    {
                        let name = res.data.message;
                        this.checkTips( name, 'warning' );
                        this.$loading().close()
                    }
                })
            },
            reqFn(paramsTwo) {
                this.$api.product.UserTokenMoneyTrade(paramsTwo).then(res => {
					this.$loading().close()
					if (res.data.code == 0) {
                        
                        this.checkTips( '积分转让成功', 'success' );
                        this.getBalance()
                        this.recordFn()

					} else {
						let name = res.data.message
						this.checkTips(name, "warning")
					}
				})
            },
            // +---------------------------------------------------------
            closeClick() {
                this.page_type = 1
                this.vipNo = ''
            },
            recordFn() {
                this.page_type = 3
                this.new_vipCard = localStorage.getItem( 'vipCard' )
                this.choosestatus(1)
            },
            choosestatus(val) {
                if (val) {
                    this.pageNo = 1
                    this.currentPage = 1
                    this.totalLength = 0
                }
            
                this.getRechargeList()
            },
            getRechargeList() {
                this.$loading()
                let params = {
                    PageNo: this.pageNo,
                    PageSize: this.pageSize,
                    Params: {
                        DateStart: this.DateStart,
                        DateEnd: this.DateEnd,
                        TradNo: ''
                    }
                }
                this.$api.product.GetUserTokenMoneyTrading(params).then(res => {
                    this.$loading().close()
                    if (res.data.code == 0) {
                        let oldData = res.data.result.data

                        for (let i = 0; i < oldData.length; i++) {
                            if (oldData[i].sellVipNo == this.new_vipCard) oldData[i].sellUserName = '本人'
                            if (oldData[i].buyVipNo == this.new_vipCard) oldData[i].buyUserName = '本人'
                        }
                        this.rechargeList = oldData
                        let totalcount = res.data.result.totalCount;
                        this.totalLength = totalcount;
                        // 计算一共有几页
                        this.totalPage = Math.ceil( totalcount / this.pageSize );
                        // 计算得0时设置为1
                        this.totalPage = this.totalPage == 0 ? 1 : this.totalPage;
                    } else {
                        this.checkTips(res.data.message, "warning")
                    }
                })
            },
            pickerReadClick() {
                if (this.value2 == null) {
                    this.DateStart = ''
                    this.DateEnd = ''
                    this.choosestatus(1)
                    return
                }

                this.DateStart = this.formatDate(this.value2[0])
                this.DateEnd = this.formatDate(this.value2[1])
                this.choosestatus(1)
            },
            //将中国标准时间转换为年月日格式
            formatTen(num) { 
                return num > 9 ? (num + "") : ("0" + num); 
            },
            formatDate(date) { 
                var year = date.getFullYear(); 
                var month = date.getMonth() + 1; 
                var day = date.getDate(); 
                var hour = date.getHours(); 
                var minute = date.getMinutes(); 
                var second = date.getSeconds(); 
                return year + "-" + this.formatTen(month) + "-" + this.formatTen(day)+ " " + this.formatTen(hour)+ ":" + this.formatTen(minute)+ ":" + this.formatTen(second); 
            },
            handleSizeChange( val )
            {
                console.log( `每页 ${val} 条` );
            },
            handleCurrentChange( val )
            {
                this.pageNo = val;
                this.choosestatus()
                // console.log( `当前页: ${val}` );
            },
            // +---------------------------------------------------------
            checkTips( name, type )
            { //用户提示
                this.$message(
                {
                    message: name,
                    type: type
                } )
            },
            wjpasswordClick() {
                this.closeaddress(4)
            },
            // +--------------------------------------
            closeaddress(val)
            {
                this.$emit( 'childFn', val )
            }

        }
    }
</script>